import { IItemDestination } from '../../../domain/CommonPage.domain';
import * as S from './ButtonViewMore.styles';
import Link from 'next/link';

type ButtonViewMoreProps = {
    selectedItem?: IItemDestination;
};

export const ButtonViewMore = ({ selectedItem }: ButtonViewMoreProps) => {
    if (!selectedItem) return null;
    const destination = selectedItem.destination;

    return (
        <S.ButtonWrapper>
            <Link href={destination.link.toLowerCase()} passHref>
                <S.Button>
                    <span>{`All ${destination.name} Partners`}</span>
                </S.Button>
            </Link>
        </S.ButtonWrapper>
    );
};
